import React from 'react';
import { Outlet } from 'react-router-dom';

const PredictiveHeatControlSavingsLayout = () => {
  return <Outlet />;
};

export default PredictiveHeatControlSavingsLayout;
